import React from "react";
import { GLOBAL_PRESETS } from "../../contexts/DateFilterContext";

const PresetList = ({ activeKey, onSelect }) => (
	<div style={{ width: 150, padding: 12, borderRight: "1px solid var(--color-border)", display: "flex", flexDirection: "column", gap: 2 }}>
		{GLOBAL_PRESETS.map(p => (
			<button
				key={p.key}
				onClick={() => onSelect(p.key)}
				style={{
					textAlign: "left", padding: "8px 10px", borderRadius: 6, border: "none",
					background: activeKey === p.key ? "rgba(111,66,193,0.12)" : "transparent",
					color: activeKey === p.key ? "#6f42c1" : "var(--color-text)",
					fontWeight: activeKey === p.key ? 700 : 500, fontSize: 13, cursor: "pointer",
				}}
			>
				{p.label}
			</button>
		))}
		<div style={{ height: 1, background: "var(--color-border)", margin: "6px 0" }} />
		<button
			onClick={() => onSelect("all")}
			style={{
				textAlign: "left", padding: "8px 10px", borderRadius: 6, border: "none",
				background: activeKey === "all" ? "rgba(111,66,193,0.12)" : "transparent",
				color: activeKey === "all" ? "#6f42c1" : "var(--color-text-light)",
				fontWeight: activeKey === "all" ? 700 : 500, fontSize: 13, cursor: "pointer",
			}}
		>
			All Time
		</button>
	</div>
);

export default PresetList;
